import * as React from 'react';
import { WorkspaceConfiguration } from '@citrite/workspace-ui-platform';
import { ConfigurationService } from 'Configuration/ConfigurationService';

export interface Configuration {
	workspaceConfiguration: WorkspaceConfiguration;
	refreshWorkspaceConfiguration(): Promise<void>;
	configurationService: ConfigurationService;
}

export const ConfigurationContext = React.createContext<Configuration>({
	workspaceConfiguration: {} as WorkspaceConfiguration,
	refreshWorkspaceConfiguration: () => Promise.resolve(),
	configurationService: new ConfigurationService({} as WorkspaceConfiguration),
});
